<template>
  <router-link
    :to="routeParams"
    class="sidebar-item"
    :class="{ open: sidebarIsOpen, current: currentRoute }"
  >
    <div class="primary-wrapper">
      <i :class="icon" />
      <transition-group name="fade">
        <span
          v-if="animationIsFinished && sidebarIsOpen"
          v-text="
            label.pluralization
              ? $t(label.text, label.pluralization)
              : label.text
          "
        />
      </transition-group>
    </div>
  </router-link>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const currentRoute = computed(() => {
  return route.name === props.routeParams.name;
});

const props = defineProps({
  label: {
    type: [String, Object],
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  routeParams: {
    type: [String, Object],
    default: "#",
  },
  animationIsFinished: {
    type: Boolean,
    required: true,
  },
  sidebarIsOpen: {
    type: Boolean,
    required: true,
  },
});
</script>
